
const setConsents = (state, consents) => {
  state.consents = consents;
};

const setCustomerThirdParty = (state, customerThirdParty) => {
  state.customerThirdParty = customerThirdParty;
};

const setRealtorThirdParty = (state, realtorThirdParty) => {
  state.realtorThirdParty = realtorThirdParty;
};

export default {
  setConsents,
  setCustomerThirdParty,
  setRealtorThirdParty,
};
